import React from 'react'
import PropTypes from 'prop-types'

import SvgIcon from 'Components/SvgIcon'

import { _TransitionIcon } from './styles'


const TransitIcon = ({ transitType, size, onClick, className }) => {
  const transitTypeLower = transitType ? transitType.toLowerCase() : 'bus'
  const markerClass = transitTypeLower + 'Marker'
  return (
    <_TransitionIcon
      className={`${markerClass} ${className}`}
      onClick={onClick}
      style={{
        width: `${size}px`,
        height: `${size}px`,
      }}
    >
      <SvgIcon
        name={`#icon-transit-${transitTypeLower}`}
        width={size / 1.8}
        height={size / 1.8}
      />
    </_TransitionIcon>
  )
}


TransitIcon.propTypes = {
  transitType: PropTypes.string,
  size: PropTypes.number,
  onClick: PropTypes.func,
  className: PropTypes.string,
}

export default TransitIcon
